import { MOSTRAR_IMAGEN_USUARIO, OCULTAR_IMAGEN_USUARIO } from './../actions/imagen-usuario';

var imagenUsuarioVisible = function imagenUsuarioVisible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case MOSTRAR_IMAGEN_USUARIO:
      return true;

    case OCULTAR_IMAGEN_USUARIO:
      return false;

    default:
      return state;
  }
};

export default imagenUsuarioVisible;